<template>
  <div class="registration-complete white-area">
    <section class="white-area with-gift-card-session-container">
      <ImgLazy
        :image-url="loginImage"
        alt-text="新規登録完了"
        aspect-ratio="375 / 178"
        class="registration-complete__image-container"
        :width="375"
        :height="178"
      />
      <h1 class="registration-complete__header headline">
        giftee へようこそ
      </h1>
      <div class="registration-complete__content">
        <p class="body">
          本登録が完了しました！
        </p>
        <p v-if="enableSubMessage" class="body">
          {{ subMessage }}
        </p>
        <p v-if="enableDescriptionMessage" class="body">
          {{ descriptionMessage }}
        </p>
        <p
          v-if="!isBackPagePresent"
          class="registration-complete__default-message"
        >
          <span>
            続けて、より詳細なプロフィール情報の登録や、プロフィールページを公開するための設定を行うことができます。
          </span>
          <span>
            公開すると、ページのURLを知っているお相手とgifteeでギフトを贈ったお相手があなたのプロフィールにアクセスでき、サービス内でより簡単にギフトを贈り合うことができるようになります。
          </span>
        </p>
      </div>
      <div class="registration-complete__button-area">
        <ButtonPrimary
          :text="primaryButtonText"
          class="registration-complete__primary-button"
          @click-primary-button="onClickPrimaryButton"
        />
        <ButtonSecondary
          v-if="!isBackPagePresent"
          text="今は設定をスキップする"
          class="registration-complete__secondary-button"
          @click-secondary-button="onClickSecondaryButton"
        />
      </div>
    </section>
  </div>
</template>

<script>
import loginImage from '../../../../../../src/images/image_login.svg'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'
import ButtonSecondary from '../../molecules/buttons/ButtonSecondary.vue'
import ImgLazy from '../../atoms/images/ImgLazy.vue'

export default {
  name: 'RegistrationComplete',
  components: { ButtonPrimary, ButtonSecondary, ImgLazy },
  props: {
    subMessage: {
      type: String,
      required: false,
      default: ''
    },
    descriptionMessage: {
      type: String,
      required: false,
      default: ''
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    primaryButtonLink: {
      type: String,
      required: true
    },
    isBackPagePresent: {
      type: Boolean,
      required: false,
      default: false
    },
    userId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loginImage: ''
    }
  },
  computed: {
    enableSubMessage() {
      return this.subMessage.length !== 0
    },
    enableDescriptionMessage() {
      return this.descriptionMessage.length !== 0
    }
  },
  created() {
    this.loginImage = loginImage
    if (this.userId) {
      dataLayer.push({
        event: 'sign_up',
        user_id: this.userId
      })
    }
    if (!this.isBackPagePresent) {
      dataLayer.push({
        event: 'view_regist_comp__profile_edit'
      })
    }
  },
  methods: {
    onClickPrimaryButton() {
      if (!this.isBackPagePresent) {
        dataLayer.push({
          event: 'click_regist_comp__profile_edit'
        })
      }
      location.href = this.primaryButtonLink
    },
    onClickSecondaryButton() {
      location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>
.registration-complete {
  min-height: calc(100vh - 110px);

  &__image-container {
    margin: 0 auto 16px;
    max-width: 100%;
    display: inline-block;
  }

  &__header {
    margin-bottom: 16px;
  }

  &__message {
    margin-bottom: 16px;
  }

  &__content {
    margin-top: 0;
    margin-bottom: 0;
    font-family: Arial;
    line-height: 1.6;
  }

  &__default-message {
    @extend %module-text;
    padding: 0 16px;
    margin: 40px auto 0 auto;
    box-sizing: border-box;
    max-width: $small-contents-width;
    text-align: left;
    display: flex;
    flex-direction: column;
    // 1行分開けたいので、文字サイズ1.4rem × line-heightの1.6で計算する
    gap: calc(1.4rem * 1.6);

    span {
      display: block;
    }
  }

  &__button-area {
    margin: auto;
    padding: 40px 16px;
    box-sizing: border-box;
    max-width: $small-contents-width;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__primary-button {
    display: inline-block;
  }
}
</style>
